module.exports = __webpack_public_path__ + "img/ro.7e4f64d6.svg";